//import SendLocalKatalkCounselPopup from "@/pages/comp/basic/katalk/local_katalk/popup/send_local_katalk_counsel";
import SendLocalKatalkCounselTodoArea from "@/pages/comp/basic/katalk/local_katalk/common/send_local_katalk_counsel";

function SendLocalKatalkCounselPopup(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    counsel_todo_pri_val_arr: [],//[{room_name:"",message:""}]
    ...props
  };

  return (
    <>
      <SendLocalKatalkCounselTodoArea
        closePopup={myProps.closePopup}
        refreshData={myProps.refreshData}
        counsel_todo_pri_val_arr={myProps.counsel_todo_pri_val_arr}
      ></SendLocalKatalkCounselTodoArea>
    </>
  );
};
export default SendLocalKatalkCounselPopup;